import { FunctionComponent } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getKountUrl } from '../../helpers/checkoutRedirects';

import { CheckoutFrame_item$key } from './__generated__/CheckoutFrame_item.graphql';

type CheckoutFrameProps = {
    item: CheckoutFrame_item$key | null;
};

//Kount is an anti fraud 3rd party
export const CheckoutFrame: FunctionComponent<CheckoutFrameProps> = props => {
    const item = useFragment(
        graphql`
            fragment CheckoutFrame_item on Item {
                serviceId
                vertical
            }
        `,
        props.item
    );
    const kountUrl = getKountUrl(item?.serviceId, item?.vertical);
    const kountImg = `<img src=${kountUrl} width="1" height="1" />`;
    const kountHTML = `<iframe src=${kountUrl} name="checkoutKountUrl" width="1" height="1" frameBorder="0" scrolling="no">${kountImg}</iframe>`;

    if (!kountUrl) {
        return null;
    }

    return <div className="checkout-kount-url" dangerouslySetInnerHTML={{ __html: kountHTML }} />;
};
